import axios from "axios";

const apiKey = process.env.GETADDRESS_API_KEY;

export default async (postCode) => {
  const url = `https://api.getAddress.io/find/${postCode}?expand=true&sort=true&api-key=${apiKey}`;

  return axios.get(url);
};
